import { render } from "./Centers.vue?vue&type=template&id=2533e25c&scoped=true"
import script from "./Centers.vue?vue&type=script&lang=js"
export * from "./Centers.vue?vue&type=script&lang=js"

import "./Centers.vue?vue&type=style&index=0&id=2533e25c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2533e25c"

export default script